import { render, staticRenderFns } from "./productsSelection.vue?vue&type=template&id=5580ff4a&class=app-bg-login&"
import script from "./productsSelection.vue?vue&type=script&lang=ts&"
export * from "./productsSelection.vue?vue&type=script&lang=ts&"
import style0 from "./productsSelection.vue?vue&type=style&index=0&id=5580ff4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports